var SwitchService = function () {
  var switchObject = {}
  var timeSelectionData = []
  var auxhiliaryPeriodicData = []
  var complexPeriodicdata = []
  var measurementId = null
  var timeSelection = {
    dateFrom: null,
    dateTo: null
  }
  var relayMeasurements = []
  var measurementDuration = 0
  var measurementStartDate = 0

  return {
    clear: function () {
      switchObject = {}
      measurementId = null
      timeSelectionData = []
      timeSelection.dateFrom = null
      timeSelection.dateTo = null
      relayMeasurements = []
      auxhiliaryPeriodicData = []
      complexPeriodicdata = []
    },
    setSwitch: function (_switch) {
      this.clear()
      switchObject = _switch
      measurementId = switchObject.LastMeasurementId
      // measurementId = 410536344
      if (switchObject.Relays != null) {
        switchObject.Relays.forEach(element => {
          var item = {
            Id: element.RailObjectId,
            Name: element.Name,
            Type: element.EventCode,
            Events: []
          }
          relayMeasurements.push(item)
        })
      }
    },
    getSwitch: function () {
      return switchObject
    },
    getPointDrives: function () {
      if (switchObject.PointDrives != null && switchObject.PointDrives.length > 0) {
        return switchObject.PointDrives
      } else {
        return null
      }
    },
    getRelays: function () {
      if (switchObject.Relays != null && switchObject.Relays.length > 0) {
        return switchObject.Relays
      } else {
        return null
      }
    },
    setMeasurementId: function (id) {
      measurementId = id
    },
    getMeasurementId: function () {
      return measurementId
    },
    setTimeSelectionData: function (data) {
      if (data) {
        timeSelectionData = data
        if (timeSelectionData.length > 0) {
          timeSelection.dateFrom = timeSelectionData[0].MeasurementDateTime
          timeSelection.dateTo = timeSelectionData[timeSelectionData.length - 1].MeasurementDateTime
        }
      } else {
        timeSelectionData = []
        timeSelection.dateFrom = null
        timeSelection.dateTo = null
      }
    },
    getTimeSelectionData: function () {
      return timeSelectionData
    },
    setAuxhiliaryPeriodicData: function (data) {
      if (data) {
        auxhiliaryPeriodicData = data
      } else {
        auxhiliaryPeriodicData = []
      }
    },
    getAuxhiliaryPeiodicData: function () {
      return auxhiliaryPeriodicData
    },
    setComplexPeriodicData: function (data) {
      if (data) {
        complexPeriodicdata = data
      } else {
        complexPeriodicdata = []
      }
    },
    getComplexPeriodicData: function () {
      return complexPeriodicdata
    },
    addRelayMeasurements: function (m) {
      if (m.RelayMeasurements != null) {
        measurementStartDate = m.MeasurementDateTime
        measurementDuration = m.ReferenceMeasurement.Duration
        relayMeasurements = m.RelayMeasurements
      }
    },
    getRelayMeasurementStartDate: function () {
      return measurementStartDate
    },
    getRelayMeasurementDuration: function () {
      return measurementDuration
    },
    getRelayMeasurements: function () {
      return relayMeasurements
    }
  }
}

export default new SwitchService()



// WEBPACK FOOTER //
// ./src/services/SwitchService.js